export const resolveFileName = (filePath: string): string => {
  return filePath.substring(filePath.lastIndexOf('/') + 1);
};
